import { render, staticRenderFns } from "./NewReleasePackageExpansionsManager.vue?vue&type=template&id=3201ab26"
import script from "./NewReleasePackageExpansionsManager.vue?vue&type=script&lang=js"
export * from "./NewReleasePackageExpansionsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports